"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSimplifiedGraphQLErrors = exports.GetFormattedGraphQlError = void 0;
var GraphQLErrorHandler = function (graphQLError) {
    var errorMessageList = [];
    var errorCount = 0;
    var genericErrorAdded = false;
    if (graphQLError && graphQLError.graphQLErrors) {
        graphQLError.graphQLErrors.map(function (error) {
            var errorMessage = error.message.includes('Backend error')
                ? error.message
                    .split(' ')
                    .slice(3)
                    .join(' ')
                : error.message;
            errorMessage = errorMessage.replace('- ', '');
            if (errorMessage.includes('Failed adding StudentCard number')) {
                errorMessageList[errorCount++] =
                    'This card number is linked to another user. Please check your card number.';
            }
            else if (errorMessage.includes('Another user is already registered with the username')) {
                errorMessageList[errorCount++] = errorMessage;
            }
            else if (errorMessage.includes('Another user is already registered with')) {
                errorMessageList[errorCount++] = "You have already registered with us, but you have not finalised your registration. Please check your inbox to find the registration link and complete registration. If you need further help, please use the \u201CNeed some help?\u201D link below.";
            }
            else if (errorMessage.includes('cannot be cancelled because the order')) {
                errorMessageList[errorCount++] = errorMessage;
            }
            else if (errorMessage.includes('Current password does not match')) {
                errorMessageList[errorCount++] =
                    'The current password entered is incorrect. Please check and try again.';
            }
            else if (errorMessage.includes('Daily Spend Limit cannot exceed')) {
                errorMessageList[errorCount++] =
                    'Daily Spend Limit cannot exceed $1000 and cannot exceed 2 decimal places.';
            }
            else if (errorMessage.includes('Value was either too large')) {
                errorMessageList[errorCount++] =
                    'The number you entered is too large. Please check the value entered and try again.';
            }
            else if (errorMessage.includes('The selected email is not available')) {
                errorMessageList[errorCount++] = 'The selected email is not available for registration.';
            }
            else if (errorMessage.includes('Validation failed:')) {
                var validationError = errorMessage
                    .split(' ')
                    .slice(3)
                    .join(' ')
                    .split('-- ');
                validationError.map(function (error) {
                    errorMessageList[errorCount++] = error.split(':').slice(1);
                });
            }
            else if (errorMessage.includes('uierror:')) {
                if (errorMessage.includes('HTTP status code of the response was not expected')) {
                    var errorMessage = errorMessage.split('uierror:').slice(1);
                    var trailingErrorMessage = errorMessage[0].split('"');
                    if (trailingErrorMessage && trailingErrorMessage.length > 1) {
                        errorMessage = trailingErrorMessage.slice(0)[0];
                    }
                }
                else {
                    var errorMessage = errorMessage
                        .split(' ')
                        .slice(1)
                        .join(' ');
                }
                errorMessageList[errorCount++] = errorMessage;
            }
            else {
                if (!genericErrorAdded) {
                    errorMessageList[errorCount++] =
                        'Oops. Something went wrong. This issue may be temporary. Please go back and try again.';
                    genericErrorAdded = true;
                }
            }
        });
    }
    return errorMessageList;
};
var GetFormattedGraphQlError = function (error, defaultErrorMessage) {
    return error.message.includes('Backend error')
        ? error.message
            .split(' ')
            .slice(4)
            .join(' ')
            .replace('uierror: ', '')
        : defaultErrorMessage ||
            'Oops. Something went wrong.This issue may be temporary. Please go back and try again. If problem persists, please contact our support team';
};
exports.GetFormattedGraphQlError = GetFormattedGraphQlError;
exports.default = GraphQLErrorHandler;
function getSimplifiedGraphQLErrors(errors, fallbackErrorMessage) {
    if (fallbackErrorMessage === void 0) { fallbackErrorMessage = 'Oops. Something went wrong. This issue may be temporary. Please go back and try again.'; }
    if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
        return [];
    }
    var simplifiedErrorMessages = [];
    try {
        for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
            var error = errors_1[_i];
            var hasBackendError = error.message.includes('Backend error');
            // don't know what's happening here, just copying this from an existing implementation
            var errorMessage = hasBackendError
                ? error.message
                    .split(' ')
                    .slice(3)
                    .join(' ')
                : error.message;
            errorMessage = errorMessage.replace('- ', '');
            if (hasFailedStudentCardNumberError(errorMessage)) {
                simplifiedErrorMessages.push('This card number is linked to another user. Please check your card number.');
            }
            else if (isAnotherUserAlreadyRegisteredWithUsername(errorMessage) ||
                hasCancelledOrderError(errorMessage)) {
                simplifiedErrorMessages.push(errorMessage);
            }
            else if (isAlreadyRegisteredWithoutFinalisationError(errorMessage)) {
                simplifiedErrorMessages.push('You have already registered with us, but you have not finalised your registration. Please check your inbox to find the registration link and complete registration. If you need further help, please use the “Need some help?” link below.');
            }
            else if (isCurrentPasswordMismatchError(errorMessage)) {
                simplifiedErrorMessages.push('The current password entered is incorrect. Please check and try again.');
            }
            else if (isDailySpendLimitError(errorMessage)) {
                simplifiedErrorMessages.push('Daily Spend Limit cannot exceed $1000 and cannot exceed 2 decimal places.');
            }
            else if (isValueTooLargeError(errorMessage)) {
                simplifiedErrorMessages.push('The number you entered is too large. Please check the value entered and try again.');
            }
            else if (isSelectedEmailUnavailable(errorMessage)) {
                simplifiedErrorMessages.push('The selected email is not available for registration.');
            }
            else if (isValidationFailedError(errorMessage)) {
                var validationError = errorMessage
                    .split(' ')
                    .slice(3)
                    .join(' ')
                    .split('-- ');
                validationError.map(function (error) {
                    var message = error.split(':').slice(1);
                    simplifiedErrorMessages.push(message);
                });
            }
            else if (isUIError(errorMessage)) {
                var messages = [];
                var uiErrorMessage = '';
                // not sure what's happening here either, copying from an existing implementation
                if (isUnexpectedHTTPStatusError(errorMessage)) {
                    messages = errorMessage.split('uierror:').slice(1);
                    var trailingErrorMessage = messages[0].split('"');
                    if (trailingErrorMessage && trailingErrorMessage.length > 1) {
                        uiErrorMessage = trailingErrorMessage.slice(0)[0];
                    }
                    else {
                        uiErrorMessage = errorMessage;
                    }
                }
                else {
                    uiErrorMessage = errorMessage
                        .split(' ')
                        .slice(1)
                        .join(' ');
                }
                simplifiedErrorMessages.push(uiErrorMessage);
            }
            else {
                simplifiedErrorMessages.push(fallbackErrorMessage);
            }
        }
    }
    catch (error) {
        simplifiedErrorMessages.push(fallbackErrorMessage);
    }
    return simplifiedErrorMessages;
}
exports.getSimplifiedGraphQLErrors = getSimplifiedGraphQLErrors;
function hasFailedStudentCardNumberError(errorMessage) {
    return errorMessage.includes('Failed adding StudentCard number');
}
function isAnotherUserAlreadyRegisteredWithUsername(errorMessage) {
    return errorMessage.includes('Another user is already registered with the username');
}
function isAlreadyRegisteredWithoutFinalisationError(errorMessage) {
    return errorMessage.includes('Another user is already registered with');
}
function hasCancelledOrderError(errorMessage) {
    return errorMessage.includes('cannot be cancelled because the order');
}
function isCurrentPasswordMismatchError(errorMessage) {
    return errorMessage.includes('Current password does not match');
}
function isDailySpendLimitError(message) {
    return message.includes('Daily Spend Limit cannot exceed');
}
function isValueTooLargeError(errorMessage) {
    return errorMessage.includes('Value was either too large');
}
function isSelectedEmailUnavailable(message) {
    return message.includes('The selected email is not available');
}
function isValidationFailedError(errorMessage) {
    return errorMessage.includes('Validation failed:');
}
function isUIError(errorMessage) {
    return errorMessage.includes('uierror:');
}
function isUnexpectedHTTPStatusError(errorMessage) {
    return errorMessage.includes('HTTP status code of the response was not expected');
}
//# sourceMappingURL=GraphQLErrorHandler.js.map